import { PageResponseVm } from "api/core/page-response.vm";
import { Type } from "class-transformer";
import { IsOptional, IsString, ValidateNested } from "class-validator";
import { PreparationAreaVm } from "./preparation-area.vm";

export class GetPreparationAreasVm extends PageResponseVm<PreparationAreaVm, string> {
    @IsString()
    @IsOptional()
    nextOffset: string | null;

    @ValidateNested({ each: true })
    @Type(() => PreparationAreaVm)
    objects: PreparationAreaVm[];
}
